import { render } from "./RelatedResourceItems.vue?vue&type=template&id=0fdb4aab"
import script from "./RelatedResourceItems.vue?vue&type=script&lang=js"
export * from "./RelatedResourceItems.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__